/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Ai_Tools_UpdatedInputs */

const en_directory_ai_tools_updated = /** @type {(inputs: Directory_Ai_Tools_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const zh_directory_ai_tools_updated = /** @type {(inputs: Directory_Ai_Tools_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新于 ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Directory_Ai_Tools_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_updated = /** @type {((inputs: Directory_Ai_Tools_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_updated(inputs)
	return zh_directory_ai_tools_updated(inputs)
});
export { directory_ai_tools_updated as "directory.ai_tools.updated" }